module.exports = __webpack_public_path__ + "media/unipod/icon-wall-tiling-white-4ce10ce0.svg";